import { useNotificationStore } from '~/shared/lib'

export interface ImageValidationConfig {
  requiredImageCount: number
  images: (string | null | undefined)[]
}

export function validateTemplateImages(config: ImageValidationConfig): boolean {
  const notificationStore = useNotificationStore()
  const { requiredImageCount, images } = config

  const requiredImageIndexes = Array.from({ length: requiredImageCount }, (_, count) => count)
  const missingImages = requiredImageIndexes.filter(index => !images?.[index])

  if (missingImages.length > 0) {
    notificationStore.notify({
      type: 'error',
      message: 'Пожалуйста, добавьте недостающие изображения',
    })
    return false
  }

  return true
}
